//import React, { useContext } from "react";
import React  from "react";
import {Button,Card,Form,Container,Row,Col    
 } from "react-bootstrap";
 
import { cargosSistema } from "data/obtenerUsuariosSistema";
import { useParams } from 'react-router-dom';
import { useUsuarioSistema } from '../hooks/useUsuarioSistema';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';


function EditarUsuarioSistema (Usuario){
  
  const parametros = useParams();
 
  let usuario=Usuario.usuarioActual.Usuario;
  const { 
    usuarioSistema,
    setUsuarioSistema,
    updateUsuarioSistema,
    resetPassword, 
    respuestaServicio } = useUsuarioSistema({Usuario:parametros.usuario,Genero:'F',CargoId:1});
  
    const usuarioActualSistema = useUsuarioSistema({Usuario:usuario,Genero:'F',CargoId:1});
    const usuarioActual=usuarioActualSistema?.usuarioSistema;
      
  
  const handleChange = event => {
    console.log("handleChange")
    let valor=event.target.value;
    if(event.target.className=='form-check-input'){
      valor=event.target.checked;
    }
    
    console.log(event.target.name)
    console.log(valor)
    setUsuarioSistema({ ...usuarioSistema, [event.target.name]: valor });
  };

  const handleRol = event => {
    let rol=0;
    if(event.target.name=='Rol1'){
      rol=1;
    }
    else if(event.target.name=='Rol2'){
      rol=2;
    }
    else if(event.target.name=='Rol3'){
      rol=3
    }
    else if(event.target.name=='Rol4'){
      rol=4;
    }
    else if(event.target.name=='Rol5'){
      rol=5;
    }
    console.warn(rol);
    
    let arreglo=[];
    if(event.target.checked){
      
      arreglo=[ ...usuarioSistema?.Roles,rol];
    }
    else{
      
      
      arreglo=usuarioSistema?.Roles?.filter(function(value, index, arr){ 
        return value != rol;
      });
    }
    
    setUsuarioSistema({ ...usuarioSistema,['Roles']:arreglo});
    
  };


  return (
    <>
      <Container fluid>
      <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Editar Usuario Sistema</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  
                  <Row>
                    
                    <Col md="6">
                      <Form.Group>
                        <label>Usuario</label>
                        <Form.Control
                          value={usuarioSistema?.Usuario}
                          disabled
                          placeholder=""
                          type="text"
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col  md="6">
                      <Form.Group>
                        <label>Nombres</label>
                        <Form.Control
                          value={usuarioSistema?.Nombres}
                          onChange={handleChange}
                          placeholder=""
                          type="text"
                          name="Nombres"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Apellido Primario</label>
                        <Form.Control
                          value={usuarioSistema?.ApellidoPrimario}
                          name="ApellidoPrimario"
                          onChange={handleChange}
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>Apellido Secundario</label>
                        <Form.Control
                          value={usuarioSistema?.ApellidoSecundario}
                          name="ApellidoSecundario"
                          onChange={handleChange}
                          placeholder=""
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Nombre Social</label>
                        <Form.Control
                          value={usuarioSistema?.NombreSocial}
                          placeholder=""
                          type="text"
                          name="NombreSocial"
                          onChange={handleChange}
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                    <Form.Group>
                        <label>Correo</label>
                        <Form.Control
                          defaultValue={usuarioSistema?.Correo}
                          placeholder=""
                          type="text"
                          name="Correo"
                          onChange={handleChange}
                        ></Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Rut</label>
                        <Form.Control
                          value={usuarioSistema?.Rut}
                          placeholder="1-9"
                          type="text"
                          name="Rut"
                          onChange={handleChange}
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                    <Form.Group controlId="Genero">
                        <label>Genero</label>
                        <Form.Control as="select"
                        //defaultValue={usuarioSistema?.Genero}
                        name="Genero"
                        onChange={handleChange}
                        value={usuarioSistema?.Genero}
                        >
                          <option value="F">Femenino</option>
                          <option value="M">Masculino</option>
                          <option value="N">No binario</option>
                          <option value="O">Otro</option>
                          <option value="P">Prefiere no decir</option>
                          
                        </Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Teléfono</label>
                        <Form.Control
                          value={usuarioSistema?.Telefono}
                          placeholder="+56959..."
                          type="text"
                          name="Telefono"
                          onChange={handleChange}
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                    <Form.Group controlId="fechaNacimiento">
                        <label>Fecha de Nacimiento</label>
                        <Form.Control
                          
                          value={usuarioSistema?.FechaNacimiento}
                          placeholder=""
                          type="date"
                          name="FechaNacimiento"
                          onChange={handleChange}
                         ></Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md="6">
                      
                      <Form.Group controlId="formCargo">
                        <label>Cargo</label>
                        <Form.Control 
                        as="select" 
                        name="CargoId" 
                        onChange={handleChange}
                        value={usuarioSistema?.CargoId}
                        >
                          <option value="6">Practicante</option>
                          <option value="5">Terapeuta Ocupacional</option>
                          <option value="4">Tallerista</option>
                          <option value="3">Psicóloga</option>
                          <option value="2">Coordinadora</option>
                          <option value="1">Administrativo</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      
                      <Form.Group>
                        <label>Habilitado</label>
                        <Form.Check className="mb-1 pl-0">
                            <Form.Check.Label>
                              <Form.Check.Input
                                //defaultChecked={usuarioSistema?.Habilitado}
                                checked={usuarioSistema?.Habilitado}
                                name="Habilitado"
                                type="checkbox"
                                onChange={handleChange}
                                disabled={!usuarioActual?.Roles?.includes(1)}

                              ></Form.Check.Input>
                              <span className="form-check-sign"></span>
                            </Form.Check.Label>
                          </Form.Check>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md="6">
                    <Form.Group>
                        <label>Permisos Sistema</label>
                        <br></br>
                        <Form.Check>
                        <Form.Check.Label>
                          <Form.Check.Input
                            name="Rol1"
                            checked={!!usuarioSistema?.Roles?.includes(1)}
                            type="checkbox"
                            disabled={!usuarioActual?.Roles?.includes(1)}
                            onChange={handleRol}>
                          </Form.Check.Input>
                          <span className="form-check-sign"></span>
                          Administrador
                        </Form.Check.Label>
                        </Form.Check>
                        <br></br>
                        
                        <Form.Check>
                        <Form.Check.Label>
                          <Form.Check.Input
                            name="Rol2"
                            checked={!!usuarioSistema?.Roles?.includes(2)}
                            type="checkbox"
                            disabled={!usuarioActual?.Roles?.includes(1)}
                            onChange={handleRol}>
                          </Form.Check.Input>
                              <span className="form-check-sign"></span>
                              Administrativo
                        </Form.Check.Label>
                        </Form.Check>
                        <br></br>
                        
                        <Form.Check>
                        <Form.Check.Label>
                            <Form.Check.Input
                              name="Rol3"
                              checked={!!usuarioSistema?.Roles?.includes(3)}
                              type="checkbox"
                              disabled={!usuarioActual?.Roles?.includes(1)}
                              onChange={handleRol}>
                            </Form.Check.Input>
                              <span className="form-check-sign"></span>
                              Terapeuta Ocupacional
                        </Form.Check.Label>
                        </Form.Check>
                        <br></br>
                        
                        <Form.Check>
                        <Form.Check.Label>
                              <Form.Check.Input
                                name="Rol4"
                                checked={!!usuarioSistema?.Roles?.includes(4)}
                                type="checkbox"
                                disabled={!usuarioActual?.Roles?.includes(1)}
                                onChange={handleRol}>
                              </Form.Check.Input>
                              <span className="form-check-sign"></span>
                              Psicóloga
                        </Form.Check.Label>
                        </Form.Check>
                        
                        <br></br>
                        <Form.Check>
                        <Form.Check.Label>
                              <Form.Check.Input
                              name="Rol5"
                              checked={!!usuarioSistema?.Roles?.includes(5)}
                              type="checkbox"
                              disabled={!usuarioActual?.Roles?.includes(1)}
                              onChange={handleRol}>
                              </Form.Check.Input>
                              <span className="form-check-sign"></span>
                              Invitado
                        </Form.Check.Label>
                        </Form.Check>

                      </Form.Group>
                    </Col>
                  </Row>
                  {!!usuarioActual?.Roles?.includes(1) || !!usuarioActual?.Roles?.includes(2)
                  ?
                  <Button
                    className="btn-fill pull-right"
                    type="submit"
                    variant="info"
                    style={{marginRight: '20px' }}
                    onClick={(e)=>{
                      e.preventDefault();
                      updateUsuarioSistema(usuarioSistema);}}>
                    Guardar
                  </Button>
                  
                  :null
                  }

                  {!!usuarioActual?.Roles?.includes(1) || !!usuarioActual?.Roles?.includes(2)
                  ?
                  <Button
                    className="btn-fill pull-right"
                    type="button"
                    variant="info"
                    onClick={(e)=>{
                      e.preventDefault();
                      resetPassword(usuarioSistema);}}>
                    Reset Contraseña
                  </Button>
                  
                  :null
                  }
                  <div className="clearfix"></div>
                  <br></br>
                  <MensajeAlerta mensajeTexto={respuestaServicio.mensajeTexto} estado={respuestaServicio.estado} />
                  
                </Form>
              </Card.Body>
            </Card>
          </Col>
          
          
      </Row>
       
      </Container>
    </>
  );
  
}

export default EditarUsuarioSistema;
